/** Grapheme-aware length so "🍔🍟" counts as 2, not 4. Used for label limits (F-301, S-009). */
export function graphemeLength(text: string): number {
  const Segmenter = (Intl as unknown as { Segmenter?: new (locale?: string, opts?: { granularity: string }) => { segment(s: string): Iterable<unknown> } }).Segmenter;
  if (Segmenter) {
    let n = 0;
    for (const _ of new Segmenter(undefined, { granularity: "grapheme" }).segment(text)) n++;
    return n;
  }
  return Array.from(text).length;
}

export const LABEL_MAX_GRAPHEMES = 24;
export const HEADER_MAX_GRAPHEMES = 40;
export const REGISTER_NAME_MAX_GRAPHEMES = 40;

// Customer directory (F-901–905, S-009). One home for every limit so the Zod contract (@shared/api) and the
// two client forms (Setup and the Sell picker) can never drift apart (D-049).
export const CUSTOMER_NAME_MAX_GRAPHEMES = 40;
/** Bounded, not format-validated: this app serves multiple countries and currencies, and a strict pattern
 * (e.g. E.164) would reject valid non-US numbers (S-009 asks for bounded length, not a specific shape). */
export const CUSTOMER_PHONE_MAX_CHARS = 30;
/** RFC 5321's practical maximum for a full address. */
export const CUSTOMER_EMAIL_MAX_CHARS = 254;
export const CUSTOMER_ADDRESS_MAX_GRAPHEMES = 200;
export const STANDING_ORDER_CADENCE_MAX_GRAPHEMES = 60;
